import { render } from "./ResultsMobile.vue?vue&type=template&id=7124e50c&scoped=true"
import script from "./ResultsMobile.vue?vue&type=script&lang=js"
export * from "./ResultsMobile.vue?vue&type=script&lang=js"

import "./ResultsMobile.vue?vue&type=style&index=0&id=7124e50c&lang=scss"
import "./ResultsMobile.vue?vue&type=style&index=1&id=7124e50c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2874961510/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7124e50c"]])

export default __exports__